var map = {
	"./australia": 679,
	"./australia.js": 679,
	"./cricinfo/africa": 580,
	"./cricinfo/africa.js": 580,
	"./cricinfo/australia": 669,
	"./cricinfo/australia.js": 669,
	"./cricinfo/bangladesh": 670,
	"./cricinfo/bangladesh.js": 670,
	"./cricinfo/global": 671,
	"./cricinfo/global.js": 671,
	"./cricinfo/india": 672,
	"./cricinfo/india.js": 672,
	"./cricinfo/newzealand": 673,
	"./cricinfo/newzealand.js": 673,
	"./cricinfo/pakistan": 674,
	"./cricinfo/pakistan.js": 674,
	"./cricinfo/srilanka": 675,
	"./cricinfo/srilanka.js": 675,
	"./cricinfo/taboola": 667,
	"./cricinfo/taboola.js": 667,
	"./cricinfo/unitedkingdom": 676,
	"./cricinfo/unitedkingdom.js": 676,
	"./cricinfo/unitedstates": 677,
	"./cricinfo/unitedstates.js": 677,
	"./en-global": 681,
	"./en-global.js": 681,
	"./india": 682,
	"./india.js": 682,
	"./philippines": 683,
	"./philippines.js": 683,
	"./portuguese/brazil": 684,
	"./portuguese/brazil.js": 684,
	"./southafrica": 686,
	"./southafrica.js": 686,
	"./spanish/argentina": 687,
	"./spanish/argentina.js": 687,
	"./spanish/chile": 688,
	"./spanish/chile.js": 688,
	"./spanish/colombia": 689,
	"./spanish/colombia.js": 689,
	"./spanish/dominicanrepublic": 690,
	"./spanish/dominicanrepublic.js": 690,
	"./spanish/ecuador": 691,
	"./spanish/ecuador.js": 691,
	"./spanish/guatemala": 692,
	"./spanish/guatemala.js": 692,
	"./spanish/mexico": 693,
	"./spanish/mexico.js": 693,
	"./spanish/panama": 694,
	"./spanish/panama.js": 694,
	"./spanish/peru": 695,
	"./spanish/peru.js": 695,
	"./spanish/spain": 696,
	"./spanish/spain.js": 696,
	"./spanish/unitedstates": 697,
	"./spanish/unitedstates.js": 697,
	"./spanish/uruguay": 698,
	"./spanish/uruguay.js": 698,
	"./spanish/venezuela": 699,
	"./spanish/venezuela.js": 699,
	"./taboola": 680,
	"./taboola.js": 680,
	"./taboolaDefaults": 668,
	"./taboolaDefaults.js": 668,
	"./unitedkingdom": 700,
	"./unitedkingdom.js": 700,
	"./unitedstates": 701,
	"./unitedstates.js": 701
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 678;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config ^\.\/.*$
// module id = 678
// module chunks = 0